import { GETAll } from "../utils/GET";

const fromShopify = () => {
	const payload = GETAll();
	return payload.shop && payload.timestamp && payload.code && payload.hmac;
};

export default fromShopify;
